"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartLineDown = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ChartLineDown = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M.178 5.87a.6.6 0 010-.852l.84-.84a.6.6 0 01.852 0l8.33 8.33 3.18-3.181a.576.576 0 01.84 0l9.603 9.602a.6.6 0 010 .852l-.84.84a.6.6 0 01-.853 0l-8.33-8.33-3.18 3.18a.576.576 0 01-.84 0L.178 5.87z" })); };
exports.ChartLineDown = ChartLineDown;
//# sourceMappingURL=chart-line-down.js.map